import { createApiClient } from '@next-qr/lib-ui/api';

const API_BASE = import.meta.env.VITE_API_URL || '';

export const planApi = createApiClient({
  baseUrl: `${API_BASE}/api/subscription/plans`,
});

export const subscriptionApi = createApiClient({
  baseUrl: `${API_BASE}/api/subscription/subscriptions`,
});
